import { render, staticRenderFns } from "./login.vue?vue&type=template&id=24cd534f&scoped=true&"
import script from "./login.ts?vue&type=script&lang=ts&"
export * from "./login.ts?vue&type=script&lang=ts&"
import style0 from "./login.vue?vue&type=style&index=0&id=24cd534f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cd534f",
  null
  
)

export default component.exports